import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { ImportModalComponent } from 'components/RootModal/modalRegistry';

import type { InvoiceSendModalProps } from './types';

const INVOICE_SEND_ROOTUI_TYPE = 'INVOICE_SEND_CONTAINER';
ImportModalComponent(INVOICE_SEND_ROOTUI_TYPE, () => import('./index'));

export const InvoiceSendUpsertAction = createAction(
  rootUiActions.createDialog.toString(),
  (props: Omit<InvoiceSendModalProps, 'dialogId'>) =>
    rootUiTypes.mkRootUiData({
      type: INVOICE_SEND_ROOTUI_TYPE,
      props: ImmutableMap({
        modalType: props?.modalType || 'drawer',
        formComponentProps: props.formComponentProps,

        onClose: props.onClose,
        stdModalApi: props.stdModalApi,

        context: props?.context,
      }),
    }),
);
